module.exports = "/images/vendor/desiigner-svg/svg/ui/accept.svg?31ed3c269ffbdbc99fd40565f4d24fe0";